module.exports = __webpack_public_path__ + "static/media/bg.ba1fda3f.png";